import { combineReducers } from 'redux'
import shoppingCart from './shoppingCart'
import navBar from './navBar'
import contactForm from './contactForm'
import feed from './feed'
import metadata from './metadata'

export default combineReducers({ shoppingCart, navBar, contactForm, feed, metadata })
